module.exports = __webpack_public_path__ + "static/media/mlflowGif.91f7173e.gif";